import repositoryProvider from "./repositoryProvider"

const mixins = [repositoryProvider];

const mixin = {
    install: function (Vue, options) {
        mixins.forEach(m => Vue.mixin(m));
    }
};

export default mixin;



// WEBPACK FOOTER //
// ./src/seedwork/mixins/index.js